module.exports = __webpack_public_path__ + "static/media/button_down_hover.e5c6a1d1.svg";